// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/InstagramAccounts_ToggleActiveInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /instagram/accounts/toggle_active
 *
 * Toggles active status of an Instagram account.
 */
import { registerContract } from './validate'

export interface InstagramAccounts_ToggleActiveInput {
instagram_account_id: number
active: boolean
}

registerContract('InstagramAccounts_ToggleActiveInput', {
  instagram_account_id: { type: 'number',  required: true },
  active:               { type: 'boolean', required: true },
})
